import React from 'react';
import { RouteProps } from 'react-router-dom';
import { authMenu, dashboardMenu } from 'menu';
import DashboardHeader from 'pages/_layout/_headers/DashboardHeader';

const headers: RouteProps[] = [
	{
		path: `*`,
		element: <DashboardHeader />,
	},
	{ path: authMenu.login.path, element: null },
	{ path: authMenu.confirmLogin.path, element: null },
	{ path: authMenu.forgetGroup.subMenu.forgetPassword.path, element: null },
	{ path: authMenu.forgetGroup.subMenu.confirmation.path, element: null },
	{ path: authMenu.forgetGroup.subMenu.resetPassword.path, element: null },
	{ path: authMenu.confirmSignUp.path, element: null },
	{ path: dashboardMenu.dashboard.path, element: <DashboardHeader /> },
];

export default headers;
